export default {"src":"/_next/static/media/jcb-logo.7d3693df.svg","height":358,"width":461,"blurWidth":0,"blurHeight":0};